import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './media/quickInput.css';
import * as dom from '../../../browser/dom.js';
import { InputBox } from '../../../browser/ui/inputbox/inputBox.js';
import { Disposable } from '../../../common/lifecycle.js';
import { StandardKeyboardEvent } from '../../../browser/keyboardEvent.js';
import Severity from '../../../common/severity.js';
import { StandardMouseEvent } from '../../../browser/mouseEvent.js';
var $ = dom.$;
export var QuickInputBox = /*#__PURE__*/function (_Disposable) {
  _inherits(QuickInputBox, _Disposable);

  var _super = _createSuper(QuickInputBox);

  function QuickInputBox(parent) {
    var _this;

    _classCallCheck(this, QuickInputBox);

    _this = _super.call(this);
    _this.parent = parent;

    _this.onKeyDown = function (handler) {
      return dom.addDisposableListener(_this.inputBox.inputElement, dom.EventType.KEY_DOWN, function (e) {
        handler(new StandardKeyboardEvent(e));
      });
    };

    _this.onMouseDown = function (handler) {
      return dom.addDisposableListener(_this.inputBox.inputElement, dom.EventType.MOUSE_DOWN, function (e) {
        handler(new StandardMouseEvent(e));
      });
    };

    _this.onDidChange = function (handler) {
      return _this.inputBox.onDidChange(handler);
    };

    _this.container = dom.append(_this.parent, $('.quick-input-box'));
    _this.inputBox = _this._register(new InputBox(_this.container, undefined));
    return _this;
  }

  _createClass(QuickInputBox, [{
    key: "value",
    get: function get() {
      return this.inputBox.value;
    },
    set: function set(value) {
      this.inputBox.value = value;
    }
  }, {
    key: "select",
    value: function select() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.inputBox.select(range);
    }
  }, {
    key: "isSelectionAtEnd",
    value: function isSelectionAtEnd() {
      return this.inputBox.isSelectionAtEnd();
    }
  }, {
    key: "placeholder",
    get: function get() {
      return this.inputBox.inputElement.getAttribute('placeholder') || '';
    },
    set: function set(placeholder) {
      this.inputBox.setPlaceHolder(placeholder);
    }
  }, {
    key: "ariaLabel",
    get: function get() {
      return this.inputBox.getAriaLabel();
    },
    set: function set(ariaLabel) {
      this.inputBox.setAriaLabel(ariaLabel);
    }
  }, {
    key: "password",
    get: function get() {
      return this.inputBox.inputElement.type === 'password';
    },
    set: function set(password) {
      this.inputBox.inputElement.type = password ? 'password' : 'text';
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(name, value) {
      this.inputBox.inputElement.setAttribute(name, value);
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(name) {
      this.inputBox.inputElement.removeAttribute(name);
    }
  }, {
    key: "showDecoration",
    value: function showDecoration(decoration) {
      if (decoration === Severity.Ignore) {
        this.inputBox.hideMessage();
      } else {
        this.inputBox.showMessage({
          type: decoration === Severity.Info ? 1
          /* INFO */
          : decoration === Severity.Warning ? 2
          /* WARNING */
          : 3
          /* ERROR */
          ,
          content: ''
        });
      }
    }
  }, {
    key: "stylesForType",
    value: function stylesForType(decoration) {
      return this.inputBox.stylesForType(decoration === Severity.Info ? 1
      /* INFO */
      : decoration === Severity.Warning ? 2
      /* WARNING */
      : 3
      /* ERROR */
      );
    }
  }, {
    key: "setFocus",
    value: function setFocus() {
      this.inputBox.focus();
    }
  }, {
    key: "layout",
    value: function layout() {
      this.inputBox.layout();
    }
  }, {
    key: "style",
    value: function style(styles) {
      this.inputBox.style(styles);
    }
  }]);

  return QuickInputBox;
}(Disposable);